/*
 * Phone model quick-nav (Izvēlies telefona modeli) for the unified
 * "Mobilie telefoni" collection. Same accordion-of-pills mechanism as the
 * accessory compatible_model widget: collapsed per-brand groups, click a pill
 * to narrow the grid. Unlike accessories (a native facet), each phone model
 * IS a distinct product — so a click either narrows the currently-loaded grid
 * to that one card, or, if the card isn't on the current page, navigates
 * straight to its PDP.
 */
(function () {
  'use strict';

  function getGrid() {
    return document.getElementById('GridContainer');
  }

  function resetNarrow() {
    var grid = getGrid();
    if (grid) {
      var items = grid.querySelectorAll('.gitem--model-hidden');
      for (var i = 0; i < items.length; i++) {
        items[i].classList.remove('gitem--model-hidden');
      }
    }
    var pills = document.querySelectorAll('.pmn-btn.active');
    for (var j = 0; j < pills.length; j++) {
      pills[j].classList.remove('active');
    }
  }

  function narrowToTitle(title, clickedBtn) {
    var grid = getGrid();
    if (!grid) return false;
    var items = grid.querySelectorAll('.gitem[data-product-title]');
    var target = null;
    for (var i = 0; i < items.length; i++) {
      if (items[i].getAttribute('data-product-title') === title) {
        target = items[i];
        break;
      }
    }
    if (!target) return false;

    /* Brand and condition stay applied. A model click only adds its own
       hide class, so the visible grid is the intersection of the three. */
    for (var j = 0; j < items.length; j++) {
      items[j].classList.toggle('gitem--model-hidden', items[j] !== target);
    }
    var pills = document.querySelectorAll('.pmn-btn.active');
    for (var k = 0; k < pills.length; k++) {
      pills[k].classList.remove('active');
    }
    if (clickedBtn) clickedBtn.classList.add('active');

    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true;
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest ? e.target.closest('[data-pmn-toggle]') : null;
    if (toggle) {
      var brand = toggle.getAttribute('data-pmn-toggle');
      var body = document.getElementById('PhoneModelNav-body-' + brand);
      if (body) {
        var isOpen = !body.classList.contains('collapsed');
        body.classList.toggle('collapsed', isOpen);
        toggle.classList.toggle('open', !isOpen);
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      }
      return;
    }

    var resetBtn = e.target.closest ? e.target.closest('[data-pmn-reset]') : null;
    if (resetBtn) {
      e.preventDefault();
      resetNarrow();
      var grid = getGrid();
      if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    var pill = e.target.closest ? e.target.closest('.pmn-btn') : null;
    if (pill) {
      var title = pill.getAttribute('data-pmn-model-title');
      var narrowed = title ? narrowToTitle(title, pill) : false;
      if (!narrowed) return; // no matching card on this page — follow the href to its PDP
      e.preventDefault();
    }
  });
})();
